import { render, staticRenderFns } from "./PaymentProductDetailsComponent.vue?vue&type=template&id=4b98715c&"
import script from "./PaymentProductDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentProductDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports